<template lang="pug">
  .dashboard
    .content(v-if="isUserLogged")
      .title.d-flex.align-items-center 
        span Your Syncs
        router-link(:to="{name: 'new-sync-list'}").ml-4
          img(src="@/assets/imgs/newSyncButton.svg").my-2
    .loader-container(v-if="loading")
        img(src="@/assets/imgs/loader-spinner.svg").my-2.loader-img
    
    .row.mt-5
      .col-md-4.tableHead SYNC NAME
      .col-md-4.tableHead FROM/TO
      .col-md-4.tableHead STATUS
    hr
    .syncs(v-if="syncList")
      SingleSyncItem(v-for="sync in syncList", v-bind:key="sync.id", :sync="sync" v-if="syncList.length > 0" @showlogs="showLogs")
      p.emptyTableMessage(v-if="syncList.length == 0") There are no Syncs yet
      //- SyncBox(v-for="sync in syncList", v-bind:key="sync.id", :sync="sync").mt-5

    .row(v-if="!isUserLogged")
      .col 
        p.emptyTableMessage
    
    LogsModal(v-if="showLogsModal" @close="closeModalLogs()" :sync="currentSyncLog")
</template>

<script>
import {LogsModal} from './LogComponents'
import {SingleSyncItem} from './DashboardComponents'
import SYNC_LIST from '../../graphql/SyncList.gql'
import {APIManager, Auth} from '../../helpers'
export default {
  name: 'Dashboard',
  props:{},
  components: {
    SingleSyncItem,
    LogsModal
  },
  data() {
    return {
      apollo: null,
      syncList: [],
      loading: true,
      showLogsModal: false,
      currentSyncLog: null
    }
  },
  mounted() {
    this.getSyncList()
  },
  methods: {
    closeModalLogs(){
      this.currentSyncLog = null
      this.showLogsModal = false
    },
    showLogs(sync){
      this.currentSyncLog = sync
      this.showLogsModal = true
    },
    getSyncList(){
      this.$apollo.query({
        // Query
        query: SYNC_LIST
      })
      .then(
        (response) => {
          this.syncList = APIManager.prepareData(response.data.smartsyncSyncsList, false)
          console.log(this.syncList)
          this.loading = false;
        }, (error) => {
          console.log(error)
          this.error = "An error occoured during processing your request."  
          this.loading = false;
        })
    },
  },
  computed: {
    isUserLogged: () => {
      return (Auth.user != null) ? true : false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import url('@/less/global.less');
  .tableHead {
    font-size: 12px;
    font-weight: 600;
    color: grey
  }
  button {
    border: none;
    padding: 10px;
    border-radius: 5px;
  }
  .custom-btn, .custom-btn:hover {
    background-color: @primary;
    a, a:hover {
      color: white !important;
      font-weight: bold;
      text-decoration: none;
    }
  }
  .title > span {
    font-weight: 600;
    font-size: 30px;
  }
  .emptyTableMessage {
    font-size: 15px;
    font-style: italic;
  }
</style>
